// import React, { useState } from 'react';
// import { Box, Button, Grid, MenuItem, Select } from '@mui/material';
// import TextInputs from 'src/components/inputs/TextInputs';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';

// const initialValue = {
//   membershipName: '',
//   membershipPrice: '',
//   duration: '',
//   rewardPointsOnPurchase: '',
//   discount: {
//     discountOnService: '',
//     serviceDiscountType: '%',
//     discountOnProduct: '',
//     productDiscountType: '%',
//     minBillAmount: '',
//     availableCount: '',
//   },
// };

// const initialFormValidation = {
//   membershipNameValidation: false,
//   membershipPriceValidation: false,
//   durationValidation: false,
//   discountOnServiceValidation: false,
//   discountOnProductValidation: false,
//   minBillAmountValidation: false,
//   availableCountValidation: false,
// };

// const DiscountType = ['%', 'INR'];

// const DiscountMembership = ({ membershipType = "discountType" }) => {
//   const { createMembership, activeBranchId, setShowMessage } = useMain();

//   const [formData, setFormData] = useState({ ...initialValue, membershipType });
//   const [formValidation, setFormValidation] = useState(initialFormValidation);
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       [name]: value,
//     }));
//     setFormValidation((prevFormValidation) => ({
//       ...prevFormValidation,
//       [`${name}Validation`]: !value.trim(),
//     }));
//   };

//   const handleDiscountChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       discount: {
//         ...prevFormData.discount,
//         [name]: value,
//       },
//     }));
//     setFormValidation((prevFormValidation) => ({
//       ...prevFormValidation,
//       [`${name}Validation`]: !(Number(value) > 0),
//     }));
//   };

//   const handleSubmit = async () => {
//     const {
//       membershipName,
//       membershipPrice,
//       duration,
//       rewardPointsOnPurchase,
//       discount,
//     } = formData;

//     const validation = {
//       membershipNameValidation: !membershipName.trim(),
//       membershipPriceValidation: !membershipPrice || !(Number(membershipPrice) > 0),
//       durationValidation: !duration || !(Number(duration) > 0),
//       discountOnServiceValidation: !(Number(discount.discountOnService) > 0),
//       discountOnProductValidation: !(Number(discount.discountOnProduct) > 0),
//       minBillAmountValidation: !(Number(discount.minBillAmount) > 0),
//       availableCountValidation: !(Number(discount.availableCount) > 0),
//     };

//     // setFormValidation(validation);
//     setFormValidation((pre) => ({ ...pre, ...validation }));

//     if (Object.values(validation).some((item) => item)) {
//       setShowMessage({
//         message: 'Please fill out all required fields correctly.',
//         messageType: 'error',
//       });
//       return;
//     }

//     try {
//       setLoading(true);
//       const res = await createMembership(
//         JSON.stringify({
//         membershipName,
//         membershipPrice: Number(membershipPrice),
//         duration: Number(duration),
//         rewardPointsOnPurchase: rewardPointsOnPurchase ? Number(rewardPointsOnPurchase) : 0,
//         discount: {
//           ...discount,
//           discountOnService: Number(discount.discountOnService),
//           discountOnProduct: Number(discount.discountOnProduct),
//           minBillAmount: Number(discount.minBillAmount),
//           availableCount: Number(discount.availableCount),
//         },
//         branchDetails: activeBranchId,
//       }));

//       if (res?.statusCode === 200) {
//         setFormData({ ...initialValue, membershipType });
//         setFormValidation({ ...initialFormValidation });
//         setShowMessage({
//           message: res.message || 'Discount membership created successfully',
//           messageType: 'success',
//         });
//       } else {
//         setShowMessage({
//           message: res.message || 'Membership not created',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       console.error('Error creating membership:', error);
//       setShowMessage({
//         message: error.message || 'Error creating membership',
//         messageType: 'error',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   console.log(formData)

//   return (
//     <div>
//       <Box style={{ marginTop: '20px' }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={4}>
//             <TextInputs
//               title={'Membership Name'}
//               name={'membershipName'}
//               value={formData?.membershipName}
//               handleChange={handleChange}
//               type={'text'}
//               fieldValidation={formValidation.membershipNameValidation}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <TextInputs
//               title={'Duration (in Months)'}
//               name={'duration'}
//               placeholder="0"
//               value={formData?.duration}
//               handleChange={handleChange}
//               type={'number'}
//               fieldValidation={formValidation.durationValidation}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <TextInputs
//               title={'Membership Price'}
//               name={'membershipPrice'}
//               placeholder="0"
//               value={formData?.membershipPrice}
//               handleChange={handleChange}
//               type={'number'}
//               fieldValidation={formValidation.membershipPriceValidation}
//             />
//           </Grid>
//         </Grid>
//       </Box>

//       <Box style={{ marginTop: '20px' }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={4}>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <TextInputs
//                   title={'Discount On Service'}
//                   name={'discountOnService'}
//                   placeholder="0"
//                   value={formData?.discount?.discountOnService}
//                   handleChange={handleDiscountChange}
//                   type={'number'}
//                   min={1}
//                   fieldValidation={formValidation.discountOnServiceValidation}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <div style={{ marginBottom: '7px', fontWeight: 'bold' }}>
//                   Discount Type
//                 </div>
//                 <Select
//                   name="serviceDiscountType"
//                   value={formData?.discount?.serviceDiscountType}
//                   onChange={handleDiscountChange}
//                   fullWidth
//                 >
//                   {DiscountType.map((type) => (
//                     <MenuItem key={type} value={type}>
//                       {type}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </Grid>
//             </Grid>
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <TextInputs
//                   title={'Discount On Product'}
//                   name={'discountOnProduct'}
//                   placeholder="0"
//                   value={formData?.discount?.discountOnProduct}
//                   handleChange={handleDiscountChange}
//                   type={'number'}
//                   fieldValidation={formValidation.discountOnProductValidation}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <div style={{ marginBottom: '7px', fontWeight: 'bold' }}>
//                   Discount Type
//                 </div>
//                 <Select
//                   name="productDiscountType"
//                   value={formData?.discount?.productDiscountType}
//                   onChange={handleDiscountChange}
//                   fullWidth
//                 >
//                   {DiscountType.map((type) => (
//                     <MenuItem key={type} value={type}>
//                       {type}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </Grid>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Box>

//       <Box style={{ marginTop: '20px' }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={4}>
//             <TextInputs
//               title={'Minimum Bill Amount'}
//               name={'minBillAmount'}
//               placeholder="0"
//               value={formData?.discount?.minBillAmount}
//               handleChange={handleDiscountChange}
//               type={'number'}
//               fieldValidation={formValidation.minBillAmountValidation}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <TextInputs
//               title={'Available Count'}
//               name={'availableCount'}
//               placeholder="0"
//               value={formData?.discount?.availableCount}
//               handleChange={handleDiscountChange}
//               type={'number'}
//               fieldValidation={formValidation.availableCountValidation}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <TextInputs
//               title={'Reward Points on Purchase'}
//               name={'rewardPointsOnPurchase'}
//               placeholder="0"
//               value={formData?.rewardPointsOnPurchase}
//               handleChange={handleChange}
//               type={'number'}
//             />
//           </Grid>
//         </Grid>
//       </Box>

//       <Box style={{ marginTop: '20px' }}>
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={handleSubmit}
//           disabled={loading}
//         >
//           Create Membership
//         </Button>
//       </Box>
//     </div>
//   );
// };

// export default DiscountMembership;

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, ToggleButton, ToggleButtonGroup } from '@mui/material';
import TextInputs from 'src/components/inputs/TextInputs';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { useEffect } from 'react';
import SelectInputs from 'src/components/inputs/SelectInputs';
import { IoStar } from "react-icons/io5";

const initialValue = {
  membershipName: '',
  membershipPrice: '',
   durationType: '',
    validTill: '',
     taxStatus: 'noGst',
  gst: '5',
  duration: '',
  rewardPointsOnPurchase: '',
  discount: {
    discountOnService: '',
    serviceDiscountType: '%',
    discountOnProduct: '',
    productDiscountType: '%',
    minBillAmount: '',
    availableCount: '',
  },
};

const taxStatusOptions = [
 { value: 'withTax', label: 'Inclusive (5% GST)' },
  { value: 'withoutTax', label: 'Exclusive (5% GST)' },
  // { value: 'noGst', label: 'No GST' },
];

const initialFormValidation = {
  membershipNameValidation: false,
  membershipPriceValidation: false,
  durationValidation: false,
  validTillValidation: false,
  durationTypeValidation: false,
  discountOnServiceValidation: false,
   taxStatusValidation: false,
  gstValidation: false,
};

const DiscountType = ['%', 'INR'];

const DurationTypes = [
  { value: 'duration', label: 'Duration (in Months)' },
  { value: 'validTill', label: 'Valid Till Date' }
];
//  const taxableValue = useMemo(() => {
//     const p = Number(formData.membershipPrice) || 0;
//     if (formData.taxStatus === 'withTax') {
//       return (p / 1.05).toFixed(2);
//     }
//     return p.toFixed(2);
//   }, [formData.membershipPrice, formData.taxStatus]);
const DiscountMembership = ({ membershipType = 'discountType' }) => {
  const { createMembership, activeBranchId, setShowMessage, branchData } = useMain();

  const [formData, setFormData] = useState({ ...initialValue, membershipType });
  const [formValidation, setFormValidation] = useState(initialFormValidation);
  const [loading, setLoading] = useState(false);
  const isGstRequired = !!(branchData?.gstNumber && branchData.gstNumber.trim().length > 0);
  const [isPriceInputFocused, setIsPriceInputFocused] = useState(false);
  const [isDiscountServiceInputFocused, setIsDiscountServiceInputFocused] = useState(false);
  const [isDiscountProductInputFocused, setIsDiscountProductInputFocused] = useState(false);


   const membershipNameInputRef = useRef(null);

     useEffect(() => {
    const timer = setTimeout(() => {
      if (membershipNameInputRef.current) {
        membershipNameInputRef.current.focus();
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  const taxableValue = useMemo(() => {
     
    const p = Number(formData.membershipPrice) || 0;
     if (!isGstRequired) {
      return p.toFixed(2);
    }
    if (formData.taxStatus === 'withTax') {
      return (p / 1.05).toFixed(2);
    }
    return p.toFixed(2);
  }, [formData.membershipPrice, formData.taxStatus, isGstRequired]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    // setFormValidation((prevFormValidation) => ({
    //   ...prevFormValidation,
    //   [`${name}Validation`]: !value.trim(),
    // }));
  };

  const handleDiscountChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      discount: {
        ...prevFormData.discount,
        [name]: value,
      },
    }));
    // setFormValidation((prevFormValidation) => ({
    //   ...prevFormValidation,
    //   [`${name}Validation`]: !(Number(value) > 0),
    // }));
  };

  // const handleDiscountTypeChange = (type, newType) => {
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     discount: {
  //       ...prevFormData.discount,
  //       [type]: newType,
  //     },
  //   }));
  // };
  const handleDiscountTypeChange = (event, newDiscountType, typeKey) => {
    if (newDiscountType !== null) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        discount: {
          ...prevFormData.discount,
          [typeKey]: newDiscountType,
        },
      }));
    }
  };

   const handleDurationTypeChange = (e) => {
    const { value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      durationType: value,
      duration: value === 'duration' ? prevFormData.duration : '',
      validTill: value === 'validTill' ? prevFormData.validTill : '',
    }));
  };

  // const handleSubmit = async () => {
  //   const {
  //     membershipName,
  //     membershipPrice,
  //     duration,
  //     rewardPointsOnPurchase,
  //     discount,
  //     membershipType,
  //   } = formData;

  //   const validation = {
  //     membershipNameValidation: !membershipName.trim(),
  //     membershipPriceValidation: !membershipPrice || !(Number(membershipPrice) > 0),
  //     durationValidation: !duration || !(Number(duration) > 0),
  //     discountOnServiceValidation: !(Number(discount.discountOnService) > 0),
  //     discountOnProductValidation: !(Number(discount.discountOnProduct) > 0),
  //     minBillAmountValidation: !(Number(discount.minBillAmount) > 0),
  //     availableCountValidation: !(Number(discount.availableCount) > 0),
  //     membershipTypeValidation: !membershipType.trim(),
  //   };

  //   setFormValidation((prev) => ({ ...prev, ...validation }));

  //   if (Object.values(validation).some((item) => item)) {
  //     setShowMessage({
  //       message: 'Please fill out all required fields correctly.',
  //       messageType: 'error',
  //     });
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     const res = await createMembership(
  //       JSON.stringify({
  //         membershipName,
  //         membershipPrice: Number(membershipPrice),
  //         duration: Number(duration),
  //         rewardPointsOnPurchase: rewardPointsOnPurchase ? Number(rewardPointsOnPurchase) : 0,
  //         discount: {
  //           ...discount,
  //           discountOnService: Number(discount.discountOnService),
  //           discountOnProduct: Number(discount.discountOnProduct),
  //           minBillAmount: Number(discount.minBillAmount),
  //           availableCount: Number(discount.availableCount),
  //         },
  //         membershipType,
  //         branchDetails: activeBranchId,
  //       }),
  //     );

  //     if (res?.statusCode === 200) {
  //       setFormData({ ...initialValue, membershipType });
  //       setFormValidation({ ...initialFormValidation });
  //       setShowMessage({
  //         message: res.message || 'Discount membership created successfully',
  //         messageType: 'success',
  //       });
  //     } else {
  //       setShowMessage({
  //         message: res.message || 'Membership not created',
  //         messageType: 'error',
  //       });
  //     }
  //   } catch (error) {
  //     console.error('Error creating membership:', error);
  //     setShowMessage({
  //       message: error.message || 'Error creating membership',
  //       messageType: 'error',
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };
   const handleSubmit = async () => {
    const {
      membershipName,
      membershipPrice,
      durationType,
      duration,
      validTill,
      discount,
       taxStatus,
      gst,
      membershipType,
    } = formData;

    const validation = {
      membershipNameValidation: !membershipName.trim(),
      membershipPriceValidation: membershipPrice === '' || isNaN(membershipPrice),
      durationTypeValidation: !durationType,
      durationValidation: durationType === 'duration' && (!duration || !(Number(duration) > 0)),
      validTillValidation: durationType === 'validTill' && !validTill,
      discountOnServiceValidation: !discount.discountOnService || Number(discount.discountOnService) <= 0,
      taxStatusValidation: isGstRequired && (taxStatus === 'noGst' || !taxStatus),
      gstValidation: !gst,
    };

    setFormValidation((prev) => ({ ...prev, ...validation }));

    if (Object.values(validation).some((item) => item)) {
      setShowMessage({
        message: 'Please fill out all required fields correctly.',
        messageType: 'error',
      });
      return;
    }

    try {
      setLoading(true);
      
      // Create base payload
      const payload = {
        membershipName,
        membershipPrice: Number(membershipPrice) || 0,
        taxStatus: isGstRequired ? formData.taxStatus : 'noGst',
                taxableValue: taxableValue,
        discount: {
          discountOnService: Number(discount.discountOnService) || 0,
          discountOnProduct: Number(discount.discountOnProduct) || 0,
          minBillAmount: Number(discount.minBillAmount) || 0,
          serviceDiscountType: discount.serviceDiscountType,
          productDiscountType: discount.productDiscountType,
        },
        membershipType,
        branchDetails: activeBranchId,
      };

      // Only include availableCount if > 0
      if (Number(discount.availableCount) > 0) {
        payload.discount.availableCount = Number(discount.availableCount);
      }

      // Add either duration or validTill based on selection
      if (durationType === 'duration') {
        payload.duration = Number(duration);
      } else {
        payload.validTill = validTill;
      }

      const res = await createMembership(JSON.stringify(payload));

      if (res?.statusCode === 200) {
        setFormData({ ...initialValue, membershipType });
        setFormValidation({ ...initialFormValidation });
        setShowMessage({
          message: res.message || 'Discount Type membership created successfully',
          messageType: 'success',
        });
      } else {
        setShowMessage({
          message: res.message || 'Membership not created',
          messageType: 'error',
        });
      }
    } catch (error) {
      console.error('Error creating membership:', error);
      setShowMessage({
        message: error.message || 'Error creating membership',
        messageType: 'error',
      });
    } finally {
      setLoading(false);
    }
  };


  // This logic disables the mouse wheel event
  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur();
      }
    };

    window.addEventListener('wheel', handleWheel);
    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  console.log(formData, "etwrte");

  return (
   <div>
      <Box style={{ marginTop: '20px' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <TextInputs
              ref={membershipNameInputRef}
              title={'Membership Name'}
              name={'membershipName'}
              value={formData?.membershipName}
              handleChange={handleChange}
              type={'text'}
              placeholder={'Membership Name'}
              fieldValidation={formValidation.membershipNameValidation}
            />
          </Grid>
          <Grid item xs={12} md={4} style={{marginTop:'1.8rem'}}>
            <FormControl fullWidth error={formValidation.durationTypeValidation}>
              <InputLabel>Duration Type </InputLabel>
              <Select
                value={formData.durationType}
                onChange={handleDurationTypeChange}
                label="Duration Type"
              >
                <MenuItem value="" disabled>
                  Select Duration Type
                </MenuItem>
                {DurationTypes.map((type) => (
                  <MenuItem key={type.value} value={type.value}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            {formData.durationType === 'duration' && (
              <TextInputs
                title={'Duration (in Months)'}
                name={'duration'}
                placeholder="0"
                min={'1'}
                value={formData?.duration}
                handleChange={handleChange}
                type={'number'}
                fieldValidation={formValidation.durationValidation}
              />
            )}
            {formData.durationType === 'validTill' && (
              <TextInputs
                title={'Valid Till Date'}
                name={'validTill'}
                value={formData?.validTill}
                handleChange={handleChange}
                type={'date'}
                fieldValidation={formValidation.validTillValidation}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          </Grid>
                    {/* {isGstRequired && (
           <Grid item xs={12} md={4} style={{marginTop:'1.8rem'}}>
            <SelectInputs
              title={`Tax Status ${isGstRequired ? '*' : ''}`}
              options={taxStatusOptions}
              name={'taxStatus'}
              value={formData?.taxStatus}
              handleChange={handleChange}
              optionTitle={'label'}
              optionValue={'value'}
              fieldValidation={formValidation.taxStatusValidation}
            />
          </Grid>
                    )} */}
        </Grid>
      </Box>

      <Box style={{ marginTop: '20px' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <label style={{
                fontSize: "15px",
                fontWeight: 600,
                marginBottom: "8px",
                display: "inline-block",
                color: "#212529"
              }}>Membership Price
                <IoStar color='red' style={{ height: '6px', fontWeight: 'bold', marginLeft: '4px' }} />
              </label>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  border: `1px solid ${formValidation.membershipPriceValidation ? 'red' : (isPriceInputFocused ? '#6174DD' : '#ced4da')}`, // Dynamic border color
                  borderRadius: '4px',
                  height:"57px",
                  transition: 'border-color 0.2s ease-in-out', // Smooth transition
                  '&:hover': {
                    borderColor: '#6174DD', // Theme color on hover
                  },
                }}
              >
                <span style={{padding: '0px 8px', fontSize: '16px', color: '#666'}}>₹</span>
                <input
                  name="membershipPrice"
                  placeholder="0"
                  value={formData.membershipPrice}
                  onChange={handleChange}
                  type="number"
                  min="0"
                  style={{
                    border: 'none',
                    outline: 'none',
                    flex: 1,
                    padding: '12px 0px',
                    fontSize: '16px',
                    background: 'transparent',
                    width: '100%'
                  }}
                  onFocus={() => setIsPriceInputFocused(true)}
                  onBlur={() => setIsPriceInputFocused(false)}
                />
                {isGstRequired && (
                  <Select
                    name="taxStatus"
                    value={formData.taxStatus || 'noGst'}
                    onChange={handleChange}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    sx={{
                      background: '#F0F0F0',
                      border: 'none',
                      height: '100%',
                      borderTopLeftRadius: '0px',
                      borderBottomLeftRadius: '0px',
                      borderTopRightRadius: '3px',
                      borderBottomRightRadius: '3px',
                      '& .MuiSelect-select': {
                        padding: '8px 16px',
                        paddingRight: '24px !important',
                        height: '100% !important',
                        display: 'flex',
                        alignItems: 'center'
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none'
                      },
                      '&:hover': {
                        background: '#e0e0e0',
                      },
                      '&.Mui-focused': {
                        background: '#e0e0e0',
                      },
                      borderLeft: '1px solid #ced4da'
                    }}
                  >
                    {taxStatusOptions.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </Box>
              {isGstRequired && (
                <Box sx={{
                  p: '8px 12px',
                  backgroundColor: '#e9ecef',
                  border: '1px solid #ced4da',
                  borderTop: 'none',
                  borderRadius: '0 0 4px 4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Taxable Value: {taxableValue}</span>
                </Box>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <label style={{
                fontSize: "15px",
                fontWeight: 600,
                marginBottom: "8px",
                display: "inline-block",
                color: "#212529"
              }}>Discount on Service
                <IoStar color='red' style={{ height: '6px', fontWeight: 'bold', marginLeft: '4px' }} />
              </label>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  border: `1px solid ${formValidation.discountOnServiceValidation ? 'red' : (isDiscountServiceInputFocused ? '#6174DD' : '#ced4da')}`,
                  borderRadius: '4px',
                  height:"57px",
                  transition: 'border-color 0.2s ease-in-out',
                  '&:hover': {
                    borderColor: '#6174DD',
                  },
                }}
              >
                <input
                  name="discountOnService"
                  placeholder="0"
                  value={formData.discount.discountOnService}
                  onChange={handleDiscountChange}
                  type="number"
                  min="0"
                  style={{
                    border: 'none',
                    outline: 'none',
                    flex: 1,
                    padding: '12px 12px',
                    fontSize: '16px',
                    background: 'transparent',
                    width: '100%'
                  }}
                  onFocus={() => setIsDiscountServiceInputFocused(true)}
                  onBlur={() => setIsDiscountServiceInputFocused(false)}
                />
                <Select
                  name="serviceDiscountType"
                  value={formData.discount.serviceDiscountType}
                  onChange={handleDiscountChange}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Discount type' }}
                  sx={{
                    background: '#F0F0F0',
                    border: 'none',
                    height: '100%',
                    borderTopLeftRadius: '0px',
                    borderBottomLeftRadius: '0px',
                    borderTopRightRadius: '3px',
                    borderBottomRightRadius: '3px',
                    '& .MuiSelect-select': {
                      padding: '8px 16px',
                      paddingRight: '24px !important',
                      height: '100% !important',
                      display: 'flex',
                      alignItems: 'center'
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none'
                    },
                    '&:hover': {
                      background: '#e0e0e0',
                    },
                    '&.Mui-focused': {
                      background: '#e0e0e0',
                    },
                    borderLeft: '1px solid #ced4da'
                  }}
                >
                  {DiscountType.map(type => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <label style={{
                fontSize: "15px",
                fontWeight: 600,
                marginBottom: "8px",
                display: "inline-block",
                color: "#212529"
              }}>Discount on Product</label>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  border: `1px solid ${isDiscountProductInputFocused ? '#6174DD' : '#ced4da'}`,
                  borderRadius: '4px',
                  height:"57px",
                  transition: 'border-color 0.2s ease-in-out',
                  '&:hover': {
                    borderColor: '#6174DD',
                  },
                }}
              >
                <input
                  name="discountOnProduct"
                  placeholder="0"
                  value={formData.discount.discountOnProduct}
                  onChange={handleDiscountChange}
                  type="number"
                  min="0"
                  style={{
                    border: 'none',
                    outline: 'none',
                    flex: 1,
                    padding: '12px 12px',
                    fontSize: '16px',
                    background: 'transparent',
                    width: '100%'
                  }}
                  onFocus={() => setIsDiscountProductInputFocused(true)}
                  onBlur={() => setIsDiscountProductInputFocused(false)}
                />
                <Select
                  name="productDiscountType"
                  value={formData.discount.productDiscountType}
                  onChange={handleDiscountChange}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Discount type' }}
                  sx={{
                    background: '#F0F0F0',
                    border: 'none',
                    height: '100%',
                    borderTopLeftRadius: '0px',
                    borderBottomLeftRadius: '0px',
                    borderTopRightRadius: '3px',
                    borderBottomRightRadius: '3px',
                    '& .MuiSelect-select': {
                      padding: '8px 16px',
                      paddingRight: '24px !important',
                      height: '100% !important',
                      display: 'flex',
                      alignItems: 'center'
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none'
                    },
                    '&:hover': {
                      background: '#e0e0e0',
                    },
                    '&.Mui-focused': {
                      background: '#e0e0e0',
                    },
                    borderLeft: '1px solid #ced4da'
                  }}
                >
                  {DiscountType.map(type => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </FormControl>
          </Grid>
        </Grid>
      </Box>

      <Box style={{ marginTop: '20px' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <TextInputs
              title={'Minimum Bill Amount'}
              name={'minBillAmount'}
              placeholder="0"
              value={formData?.discount?.minBillAmount}
              handleChange={handleDiscountChange}
              type={'number'}
              min={'0'}
              required={false}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextInputs
              title={'Available Count'}
              name={'availableCount'}
              value={formData?.discount?.availableCount}
              handleChange={handleDiscountChange}
              type={'number'}
              min={'0'}
              placeholder={'0'}
              required={false}
            />
          </Grid>
        </Grid>
      </Box>

      {loading ? (
          <ShowLoader />
          ) : (
            <div style={{ width: '200px', margin: '3rem auto' }}>
              <Button
                variant="contained"
                fullWidth
                color="primary"
                sx={{
                  background: '#6174DD',
                }}
                onClick={handleSubmit}
              >
                Create Membership
              </Button>
            </div>
       )}
    </div>
  );
};

export default DiscountMembership;
